export default {
	model: {
		prop: "checked",
		event: "change",
	},

	props: {
		checked: Boolean,
		label: String,
		// if provided this value will be emitted if checked is true
		value: [String, Number],
	},

	methods: { onChange },
};

function onChange(event) {
	const checked = event.target.checked;

	if (this.value) {
		if (checked) this.$emit("change", this.value);
		else this.$emit("change", null);
	} else this.$emit("change", checked);
}
